import { memo } from 'react';

import { useSaturationPointerStyles } from './styles';

function SaturationPointer() {
  const classes = useSaturationPointerStyles();

  return <div className={classes.root} />;
}

export default memo(SaturationPointer);
